import React from 'react';
import Menu, { SubMenu, MenuItem } from 'rc-menu';
import $ from 'jquery/dist/jquery';
import _ from 'underscore';
import { withAuth0 } from '@auth0/auth0-react';
import { withRouter } from 'react-router';

import { webApiConfig } from 'src/config';

class NavBar extends React.Component {
  constructor(props) {
    super(props);
    this.path = {
      "1": "/profile/edit",
      "2": "/profile/edit_password",
    }
    this.currentKey = this.currentPathKey(this.props.location.pathname)
    this.state = {
      defaultSelectedKeys: [this.currentKey],
      defaultOpenKeys: this.genDefaultOpenKeys(this.currentKey),
    }
  }

  currentPathKey(path) {
    const result = Object.keys(this.path).filter((k) => { return this.path[k] == path })[0];
    if (result) {
      return result;
    } else {
      switch(path.split("/")[3]) {
        default :
          return "1";
          break;
      }
    }
  }

  genDefaultOpenKeys(key) {
    const defaultOpenKeys = [];
    const array = key.split('-');
    for (let i=array.length; i>0; i-=1) {
      defaultOpenKeys.push(array.join('-'));
      array.pop();
    }
    return defaultOpenKeys;
  }

  onClick(info) {
    this.props.history.push(this.path[info.key]);
  }

  getMenu() {
    return (
      <Menu
        onClick={this.onClick.bind(this)}
        mode="inline"
        defaultSelectedKeys={this.state.defaultSelectedKeys}
        defaultOpenKeys={this.state.defaultOpenKeys}
      >
        <MenuItem key="1">ユーザ情報</MenuItem>
        <MenuItem key="2">パスワード</MenuItem>
      </Menu>
    );
  }

  render() {
    return (<div>
      <div>{this.getMenu()}</div>
    </div>);
  }
}

export default withAuth0(withRouter(NavBar));
